import React, { useState } from 'react'
import CarRegCustomSelectBox from '../BookingFormComponents/CarRegCustomSelectBox'
import ServicesCustomSelectBox from '../BookingFormComponents/servicesCustomSelectBox/index'
import BookingFormLocation from '../BookingFormComponents/BookingFormLocation'
import DynamicForm from '../FormElements/DynamicForm'
import { Button } from 'antd'
import VehicleRegistration from '../VehicleRegistration'
import { Colors } from '../../config'
import * as Yup from 'yup'
import CarDetailBox from '../BookingFormComponents/CarDetailBox'

const BookingForm = ({ bookingFormDataOrStatusHandler, editData = null, selectedFiltersValue = null, spServicesData, isServicesFilled = false }) => {
    const [vehicleRegistrationModalOpen, setVehicleRegistrationModalOpen] = useState(false);
    const [servicesCustomError, setServicesCustomError] = useState(false);
    const [fetchedVehicleData, setFetchedVehicleData] = useState(null)
    const [formUpdatedFields, setFormUpdatedFields] = useState(null);


    const vehicleRegistrationModal = () => {
        setVehicleRegistrationModalOpen(true)
    }

    const handleFetchedCarData = (data) => {
        if (data) {
            setFetchedVehicleData(data?.data?.newVehicle)
            setFormUpdatedFields(data?.data?.newVehicle); 
        }
    }

    const handleSubmit = (values) => {
        if (values?.services === undefined) {
            setServicesCustomError(true);
            return
        }

        // now here i can destrcture the data as per the api needs.
        else if (values.services !== undefined && !servicesCustomError) {
            setServicesCustomError(false)
            setFormUpdatedFields(null)
            const { carDetails, ...restData } = values;
            console.log(values?.selectedCategories)
            bookingFormDataOrStatusHandler({ ...restData, fetchedVehicleData, engineSize: fetchedVehicleData?.engineSize + '' })
            return
        }

        else {
            setServicesCustomError(true)
            return
        }
    };

    const submitForm = () => {
        document.querySelector('form#bookingForm')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    }

    // receiving a data or any status after a submission of registration form.
    const vehicleRegistrationFormDataHandler = (data) => {
        console.log(data)
    }

    let form = {
        name: 'bookingForm',
        formFields: [
            {
                name: 'carRegNo',
                type: 'custom',
                label: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: <CarRegCustomSelectBox myCar={(data) => handleFetchedCarData(data)} />,
                classes: '',
                icon: null,
            },
            {
                name: 'forgot',
                type: 'custom',
                label: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: <div className='w-full flex justify-end'>
                    <p className={`text-white ${!formUpdatedFields ? 'h-11' : ''} mb-1 text-end underline w-fit cursor-pointer my-2`} onClick={vehicleRegistrationModal}>Forgot my vehicle registration</p>
                </div>,
                classes: '',
                icon: null,
            },
            {
                name: 'carDetails',
                type: 'custom',
                label: '',
                width: { md: formUpdatedFields ? 24 : 0, sm: formUpdatedFields ? 24 : 0, xs: formUpdatedFields ? 24 : 0 },
                component: formUpdatedFields && <div className='mb-4'><CarDetailBox carDetails={formUpdatedFields} /></div>,
                classes: '',
                icon: null,
            },
            {
                name: 'services',
                type: 'custom',
                label: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: <ServicesCustomSelectBox classes='bg-white mt-[-2rem]' servicesCustomError={servicesCustomError} setServicesCustomError={setServicesCustomError} selectedFiltersValue={selectedFiltersValue} spServicesData={spServicesData} isServicesFilled={isServicesFilled} />,
                classes: '',
                icon: null,
            },
            {
                name: 'location',
                type: 'custom',
                label: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: <BookingFormLocation />,
                classes: '',
                icon: null,
            },
            {
                name: 'details',
                type: 'textarea',
                label: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                placeholder: 'Additional Info / Note',
                classes: '',
                icon: null,
            },
        ],
        formValidation: {
            // for services we are handling custom error because over there we are opening a modal to select sub services.
            carRegNo: Yup.string()
                .test('is-required', 'No is required', function (value) {
                    return !!value; // Ensure the value exists (non-empty)
                })
                .test(
                    'conditional-validation',
                    'Input must be exactly 7 characters and follow the pattern',
                    function (value) {
                        if (!value) {
                            return true; // Skip length and pattern validation if the field is empty
                        }
                        if (value.startsWith('aaa') || value.startsWith('AAA')) {
                            return true; // No pattern or length validation if it starts with 'aaa' or 'AAA'
                        }
                        const ukCarRegPattern = /^[A-Z]{2}[0-9]{2}[A-Z]{3}$/i; // Case-insensitive pattern for UK car registration
                        return value.length === 7 && ukCarRegPattern.test(value); // Validate length and pattern
                    }
                ),
            location: Yup.object()
                .shape({
                    address: Yup.string()
                        .required('Postal Code is required')
                })
                .required('Postal Code is required') // Ensures the location object exists
                .test('hasKeys', 'Postal Code is required', value => value && 'address' in value
                ),
            details: Yup.string().max(1000).notRequired(),
            services: Yup.array()
                .of(
                    Yup.mixed()
                        .test('is-valid-id', 'ID must be a number or a string', (value) =>
                            typeof value === 'number' || typeof value === 'string'
                        )
                        .required('ID is required')
                )
                .min(1, 'At least one item is required')
        }
    }

    return (
        <div className='w-full'>
            <DynamicForm editData={editData} id="bookingForm" form={form} onSubmit={handleSubmit} />
            <Button
                onClick={submitForm}
                className={`w-full h-16 rounded-md outline-none border-none bg-[${Colors.AppYellow}] text-white booking-btn`}
            >
                Book Now</Button>
            <VehicleRegistration
                vehicleRegistrationModalOpen={vehicleRegistrationModalOpen}
                setVehicleRegistrationModalOpen={setVehicleRegistrationModalOpen}
                vehicleRegistrationFormDataHandler={vehicleRegistrationFormDataHandler}
            />
        </div>
    )
}

export default BookingForm